import React from 'react';
import { Chip, ChipProps } from '@mui/material';

import './CustomChip.css';

export const CustomChip: React.FC<ChipProps> = ({ ...other }) => {
  return <Chip {...other} />;
};
